import styled, {css} from 'styled-components'

const Celula = styled.span`
  display: flex;
  justify-content: ${props => props.align || "inherit"};
  align-items: center;
  font-size: 12px;
  padding-right: 3px;
  /* &:hover {
    background: rgba(0,0,0,.1);
  } */
  ${props=>props.onClick && css`
    cursor: pointer;
  `}
`;

export default Celula

  /* cursor: ${props => props.cursor || "inherit"}; */
  /* grid-column: ${props => props.idx + 2 || "auto"}; */
  /* background-color: ${setColor}; */
  /* color: ${props => props.neg && "red" || "black"}; */
